<div class="ui-modal">
  <div class="header flex-row space-between-center">
    <span>{{ 'SUAS.ACCOUNT.DETAILS.TITLE' | translate }}</span>
    <span class="ui-icon-close c-p" matDialogClose></span>
  </div>
  <div class="body">
    <div class="flex-col gap-8">
      <label>{{ 'SUAS.ACCOUNT.DETAILS.WEEKLY_EMAILS' | translate }}</label>
      <div class="flex-row start-center gap-12">
        <ui-toggle [formControl]="weeklySubscriptionFormControl"></ui-toggle>
        <span>{{ 'SUAS.ACCOUNT.DETAILS.WEEKLY_EMAILS_ENABLE' | translate }}</span>
      </div>
      <div class="description">
        {{ 'SUAS.ACCOUNT.DETAILS.WEEKLY_EMAILS_DESC' | translate }}
      </div>
    </div>
  </div>
  <div class="footer flex-row end-center gap-8">
    <ui-button
      [text]="'SUAS.COMMON.CANCEL' | translate"
      type="default"
      (clickAction)="close()"
    ></ui-button>
    <ui-button
      [disabled]="weeklySubscriptionFormControl.invalid"
      [text]="'SUAS.COMMON.SAVE' | translate"
      (clickAction)="save()"
    ></ui-button>
  </div>
</div>
